// extracted by mini-css-extract-plugin
export var brand = "_4l-9";
export var compact = "_4l-6";
export var extraSmall = "_4l-7";
export var icon = "_4l-0";
export var large = "_4l-4";
export var light = "_4l-1";
export var medium = "_4l-5";
export var outline = "_4l-b";
export var primaryDark = "_4l-a";
export var primaryLight = "_4l-8";
export var primaryModern = "_4l-c";
export var success = "_4l-2";
export var successSolid = "_4l-3";